import { render, staticRenderFns } from "./cadunidades.vue?vue&type=template&id=3b2e4e67&"
import script from "./cadunidades.vue?vue&type=script&lang=js&"
export * from "./cadunidades.vue?vue&type=script&lang=js&"
import style0 from "./cadunidades.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports